import { render, staticRenderFns } from "./cLandingLinks.vue?vue&type=template&id=d5dd5a22&scoped=true"
import script from "./cLandingLinks.vue?vue&type=script&lang=js"
export * from "./cLandingLinks.vue?vue&type=script&lang=js"
import style0 from "./cLandingLinks.vue?vue&type=style&index=0&id=d5dd5a22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dd5a22",
  null
  
)

export default component.exports